import React from 'react';
import ReactDOM from 'react-dom';
import AppendModal from '@/src/support/modal/AppendModal';

export default class ModalWrap extends React.Component {
  constructor (props) {
    super(props);
		this.currentData= null;
    this.AppendModal= new AppendModal({
      willOpenCallback: this.modalOpenCallback,
      didCloseCallback: this.modalCloseCallback,
      containerClassName: 'modal-container',
      openClassName: 'on'
		});
	}

	modalOpenCallback= ( modal )=> {
    ReactDOM.render(
      React.cloneElement(this.props.children),
      document.body.appendChild(modal.container)
    );
  }

  modalCloseCallback= ( modal )=> {
    ReactDOM.unmountComponentAtNode(modal.container);
  }

  componentDidUpdate () {
		if( this.props.modalDetail === 'init' ) return;
    if( this.props.modalDetail ) {
      this.AppendModal.willOpen();
    } else {
      this.AppendModal.willClose();
    }
  }
  
  componentDidMount () {
		if( this.props.modalDetail === 'init' ) return;
    if( this.props.modalDetail ) {
      this.AppendModal.willOpen();
    }
	}

  render () {
    return (
			<>
			</>
		)
  }
}